// Spawn protection as the HUD shows it: the server only says whether the local player is protected,
// so the time left is estimated from the rules, the spawn tick and the Defusal freeze.

import type { MatchPhase } from "../hud/types";

/**
 * Share of the spawn protection left (1 = all of it, 0 = none). `startTick` is where the
 * protection timer starts: the spawn, or in a Defusal freeze its expected end (`shieldStart`).
 * Never 0 while the server still says `protected` (a late snapshot keeps the bar on).
 */
export function spawnShieldLeft(
  isProtected: boolean,
  startTick: number,
  nowTick: number,
  protectSec: number,
  tickRate: number,
): number {
  if (!isProtected) return 0;
  const total = protectSec * tickRate;
  if (!(total > 0)) return 1;
  const left = (startTick + total - nowTick) / total;
  return left > 1 ? 1 : left < 0.04 ? 0.04 : left;
}

/** Tick the protection timer of a player who spawned at `spawnTick` starts at in `phase`. */
export function shieldStart(
  spawnTick: number,
  phase: MatchPhase,
  phaseEndTick: number,
): number {
  return phase === "round_freeze"
    ? Math.max(spawnTick, phaseEndTick)
    : spawnTick;
}
